/* eslint-disable @typescript-eslint/no-explicit-any */
import { CustomFieldSchema, Field } from '../types/Form';
import { Control, Controller } from 'react-hook-form';
import {
  AgentInput,
  TextField,
  RadioGroup,
  Select,
  Dropdown,
  ServerDropdown,
  Checkbox,
  TimeSlots,
  ChipInput,
  StepSlider,
  TimeRangeField,
  TemplatedInput,
  DateSlots
} from '../components';

export const renderField = (
  [name, rField]: [string, Field],
  control: Control<any>
) => {
  // Early return for hidden fields
  // This is a fallback - hidden fields should already be filtered out in getGroupedFields
  if (rField.hidden) {
    return null;
  }

  if (rField.type === 'custom') {
    // FieldSchema members are intersections, not a discriminated union, so this
    // doesn't narrow. Changing that shape touches 87 importers.
    const customField = rField as CustomFieldSchema;
    return (
      <Controller
        key={name}
        name={name}
        control={control}
        defaultValue={customField.defaultValue}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            {customField.render({
              name,
              value,
              onChange,
              field: customField,
              error: !!error,
              errorMessage: error?.message
            })}
          </>
        )}
      />
    );
  }

  let Component: any = null;

  switch (rField.type) {
    case 'text':
      Component = TextField;
      break;
    case 'password':
      Component = TextField;
      break;
    case 'textarea':
      Component = TextField;
      break;
    case 'radio':
      Component = RadioGroup;
      break;
    case 'select':
      Component = Select;
      break;
    case 'dropdown':
      Component = Dropdown;
      break;
    case 'server-dropdown':
      Component = ServerDropdown;
      break;
    case 'checkbox':
      Component = Checkbox;
      break;
    case 'timeSlots':
      Component = TimeSlots;
      break;
    case 'timeRange':
      Component = TimeRangeField;
      break;
    case 'chipInput':
      Component = ChipInput;
      break;
    case 'templated-text':
      Component = TemplatedInput;
      break;
    case 'stepSlider':
      Component = StepSlider;
      break;
    case 'agentInput':
      Component = AgentInput;
      break;
    case 'dateSlots':
      Component = DateSlots;
      break;
    default:
      throw new Error(`Field type ${(rField as any).type} not supported`);
  }

  return (
    <Controller
      key={name}
      name={name}
      control={control}
      defaultValue={rField.defaultValue}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const err = error as any;
        return (
          <Component
            name={name}
            value={value}
            onChange={onChange}
            field={rField}
            id={name}
            data-testid={name}
            errorMessage={
              err?.length === undefined
                ? err?.message
                : err.find((e: any) => e?.message)?.message
            }
          />
        );
      }}
    />
  );
};
